import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appPhoneNumber]'
})
export class PhoneNumberValidDirective {
  // Allow decimal numbers and negative values
  private regex: RegExp = new RegExp(/^\d*\.?\d{0,4}$/g);
  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-', 'Delete'];

  constructor(private el: ElementRef) {
  }
  @HostListener('input', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    // // console.log.log(this.el.nativeElement.value);
    // Allow Backspace, tab, end, and home keys
    if (event['data'] == null) {
      return;
    }
    let current: string = this.el.nativeElement.value;
    let next: string = current;
    let nextWithout = next.replace(new RegExp('-', 'g'), '');
    if (nextWithout && !String(nextWithout).match(this.regex)) {
      event.preventDefault();
    } else {
        if (next.length == 3) {
            this.el.nativeElement.value = next + '-';
            event.preventDefault();
        } else if (next.length == 7) {
            this.el.nativeElement.value = next + '-';
            event.preventDefault();
        }
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event) {
    let next = event.clipboardData.getData('Text');
    let ph_val = next.replace(/\D[^\.]/g, "");
    let phone = ph_val.slice(0, 3) + "-" + ph_val.slice(3, 6) + "-" + ph_val.slice(6);
    this.el.nativeElement.value = phone;
    event.preventDefault();
  }
}

